// extracted by mini-css-extract-plugin
module.exports = {"block":"block___1ocbp","FUploadImageChildren":"FUploadImageChildren___3dnqA","cover":"cover___1EIAy","coverEdit":"coverEdit___Uf62r","btn":"btn___2Cb2P"};